import { Controller } from "stimulus"
import Swal from "sweetalert2";
import tippy from 'tippy.js';
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";

export default class extends Controller {
  static targets = [ 'entryCard', 'modal', 'form' ];

  connect() {
    AjaxLoader.hide();
    let isShow = this.entryCardTarget.dataset.modalOpen === 'true',
      keyboard = !(this.entryCardTarget.dataset.modalKeyboard === 'false');

    this.element.querySelector('.inner-card').addEventListener('click', () => this.edit() );

    $(this.modalTarget).modal({
      focus: isShow,
      show: isShow,
      keyboard: keyboard,
      backdrop: false
    })
      .on('show.bs.modal', (ev) => { this.modalTarget.classList.remove('no-animate') });

    tippy('[data-tippy-content]', {
      allowHTML: true,
      animation: 'scale',
      interactive: true,
      theme: 'traus-light',
      appendTo: this.modalTarget
    });
  }

  remove() {
    Swal.fire({
      title: 'Atenção',
      icon: 'warning',
      text: 'Deseja realmente remover?',
      showClass: { backdrop: 'swal2-noanimation', popup: '', },
      hideClass: { popup: '' },
      customClass: {
        cancelButton: 'btn btn-gray-primary',
        confirmButton: 'btn btn-primary mr-3'
      },
      buttonsStyling: false,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
			if (!result.value) return;

      this.element.closest('turbo-frame').remove();
    });
  }

  edit() {
    $(this.modalTarget).modal('show');
  }

  close() {
    $(this.modalTarget).modal('hide');
  }

  save() {
    $(this.modalTarget).modal('hide');
    AjaxLoader.show();
  }
}